<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row d-flex justify-content-between">
              <div class="col-md-4 col-sm-6">
                Filter Fixture Date
              </div>
              <div class="col-md-8 col-sm-6 text-right">
                <date-range-picker
                    ref="picker"
                    opens="left"
                    :locale-data="{
                            firstDay: 1,
                            format: 'dd-mm-yyyy',
                          }"
                    :showDropdowns="true"
                    :autoApply="true"
                    v-model="dateRange"
                    @update="dateFilter($event)"
                    @toggle="true"
                    :linkedCalendars="true"
                    :date-format="dateFormat"
                >
                  <template
                      v-slot:sui-input="picker"
                  >
                    {{ picker.startDate | date }} - {{ picker.endDate | date}}
                  </template>
                </date-range-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card card-user">
          <div class="card-header">
            <h5 class="card-title">Add Prediction</h5>
          </div>
          <div class="card-body">
            <sui-form>
              <sui-form-field>
                <label>Fixture</label>
                <sui-dropdown
                    placeholder="Fixture"
                    selection
                    search
                    :options="fixtures"
                    v-model="fixtureId"
                />
              </sui-form-field>
              <sui-form-field>
                <label>Prediction Type</label>
                <sui-dropdown
                    placeholder="Prediction Type"
                    selection
                    search
                    :options="types"
                    v-model="apiFootballId"
                />
              </sui-form-field>
              <sui-form-field v-if="apiFootballId">
                <label>Prediction</label>
                <sui-dropdown
                    placeholder="Prediction"
                    selection
                    search
                    :options="list"
                    v-model="predictionTypeListId"
                />
              </sui-form-field>
              <div class="row">
                <div class="update ml-auto mr-auto">
                  <button type="submit" class="btn btn-success btn-round" @click.prevent="add">Add Prediction</button>
                </div>
              </div>
            </sui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  components: {
    DateRangePicker,
  },
  data(){
    let startDate = new Date();
    let endDate = new Date();
    endDate.setDate(endDate.getDate() - 30);
    return {
      types: [],
      list: [],
      fixtures: [],
      apiFootballId: null,
      fixtureId: null,
      predictionTypeListId: null,
      moreParams: {
        start: "",
        end: "",
        limit: true,
      },
      dateRange: { startDate, endDate },
    }
  },
  mounted() {
    this.moreParams.start = moment().format('YYYY-MM-DD')
    this.moreParams.end = moment().format('YYYY-MM-DD')
    this.setPredictionTypes()
    this.setFixtures()
  },
  watch: {
    apiFootballId(newVal, oldVal){
      if (newVal !== oldVal){
        this.setPredictionTypeList(newVal)
      }
    }
  },
  methods: {
    ...mapActions(['getPredictionList', 'getPredictionTypeList', 'getFixtures', 'addPrediction']),
    dateFormat (classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() > new Date()
      }
      return classes
    },
    dateFilter: function (event) {

      var vm = this;

      vm.moreParams.start = moment(event.startDate).format('YYYY-MM-DD')
      vm.moreParams.end = moment(event.endDate).format('YYYY-MM-DD')

      this.setFixtures();
    },
    async setPredictionTypes() {
      let app = this
      let response = await this.getPredictionList()
      if (response.status === 200){
        response.message.forEach(function (item) {
          let list = { text: item.name, value: item.apiFootballId }
          app.types.push(list)
        })
      }
    },
    async setFixtures() {
      let app = this
      let response = await this.getFixtures(app.moreParams)
      if (response.status === 200){
        app.fixtures = []
        response.message.forEach(function (item) {
          let name = item.leagueName + ' - ' + item.homeTeamName + ' vs ' + item.awayTeamName
          let list = { text: name, value: item.id }
          app.fixtures.push(list)
        })
      }
    },
    async setPredictionTypeList(id) {
      let app = this
      app.list = []
      let response = await this.getPredictionTypeList(id)
      if (response.status === 200){
        response.message.forEach(function (item) {
          let list = { text: item.name, value: item.id }
          app.list.push(list)
        })
      }
    },
    async add(){
      let app = this
      let payload = {
        apiFootballId: app.apiFootballId,
        fixtureId: app.fixtureId,
        predictionTypeListId: app.predictionTypeListId
      }
      app.$swal.fire({
        title: 'Are you sure?',
        text: "Doing this adds a new prediction!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, add!',
        closeOnConfirm: false,
        showLoaderOnConfirm: true,
        preConfirm: async (res) => {
          return await this.addPrediction(payload)

        },
      })
          .then(async (result) => {
            if (result.value.status === 201) {
              app.$swal.fire({
                title: 'Added!',
                text: 'Prediction added successful',
                icon: 'success'
              }) .then(async (result) => {
                app.resetForm()
                //await app.setRoles()
              })

            } else {
              app.$swal.fire('Error!', result.value.message, 'error')
            }
          })
    },
    resetForm(){
      this.apiFootballId = null
      this.fixtureId = null
      this.predictionTypeListId = null
    }
  }
}
</script>
<style>

</style>
